// extracted by mini-css-extract-plugin
export default {"button":"StyleButton_button__7aDvr","activeButton":"StyleButton_activeButton__TfvBt","tooltip":"StyleButton_tooltip__LguXJ"};